import NoticeIcon from 'assets/icons/notice-yellow-icon.svg';
import ButtonCommon from 'components/common/ButtonCommon';
import SizeBox from 'components/common/SizeBox';
import {
  DESKTOP_MIN_WIDTH,
  MOBILE_MIN_WIDTH,
  TABLET_MAX_WIDTH,
} from 'constants';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';
import {
  displayFlexColCenterCenterMixin,
  paragraph500Mixin,
  paragraphMixin,
} from 'styles';

const AccountWithEmailExistInformPopup = ({
  isOpen,
  buttonLabel1,
  onClose,
  buttonLabel2,
  onClick,
  isBackdropOverlap,
  zIndexBackdropOverlap,
  zIndexModal = 0,
}) => {
  const { t } = useLang();
  const { isDesktop } = useDetectDevice();

  const renderContentMessage = () => {
    return (
      <SubText
        dangerouslySetInnerHTML={{
          __html: t('form_registration_account_with_email_exist_inform'),
        }}
      />
    );
  };
  const renderBodyContent = () => (
    <>
      <ImageWrap>
        <img
          src={NoticeIcon}
          alt=""
          width={isDesktop ? '75px' : '75px'}
          height={isDesktop ? '60px' : '60px'}
        />
      </ImageWrap>
      <SizeBox height={isDesktop ? 10 : 16} />
      {renderContentMessage()}
      <SizeBox height={isDesktop ? 24 : 40} />
    </>
  );

  const renderActionButton1 = (width) => (
    <ButtonCommon
      value={buttonLabel1}
      onClick={onClose}
      styles={{
        margin: '0px',
        height: '50px',
        width,
      }}
      color="var(--ds-c-red)"
      background="var(--ds-c-white)"
    />
  );
  const renderActionButton2 = (width) => (
    <ButtonCommon
      value={buttonLabel2}
      color="var(--c-primary)"
      background="var(--bg-primary)"
      isFill={true}
      styles={{
        margin: '0px',
        height: '50px',
        width,
      }}
      onClick={onClick}
      isUseKeyDown
    />
  );
  const renderActionButtons = () => {
    if (isDesktop)
      return (
        <>
          {renderActionButton1('50%')}
          {renderActionButton2('50%')}
        </>
      );
    return (
      <>
        {renderActionButton2('100%')}
        <SizeBox height={10} />
        {renderActionButton1('100%')}
      </>
    );
  };

  return (
    <>
      <style>
        {zIndexModal &&
          `
          @media screen and (max-width: ${TABLET_MAX_WIDTH - 1}px) {
            .account-with-email-exist-inform-modal {
              z-index: ${zIndexModal || '1101'};
            }
          }
        `}
        {isBackdropOverlap
          ? `
          .account-with-email-exist-inform-modal-backdrop {
            z-index: ${zIndexBackdropOverlap || '1100'};
            background: #212121;
            opacity: 0.7!important;
            display: initial!important;
          }
        `
          : `
        .account-with-email-exist-inform-modal-backdrop {
          background: #212121;
          opacity: 0.7!important;
          display: initial!important;
        }
      `}
      </style>
      <ModalStyled
        show={isOpen}
        onHide={() => {}}
        aria-labelledby="contained-modal-title-vcenter"
        className="account-with-email-exist-inform-modal"
        backdropClassName="account-with-email-exist-inform-modal-backdrop"
        centered
      >
        <ModalBody>{renderBodyContent()}</ModalBody>
        <ModalFooter>{renderActionButtons()}</ModalFooter>
      </ModalStyled>
    </>
  );
};

const ModalStyled = styled(Modal)`
  @media screen and (min-width: ${MOBILE_MIN_WIDTH}px) and (max-width: ${TABLET_MAX_WIDTH -
    1}px) {
    & .modal-dialog {
      position: absolute;
      margin: 0;
      top: 0px;
      height: 100dvh;
      width: 100%;
      max-width: 100%;
      align-items: end;
      transition: ease-out 0.3s !important;
      transform: none;

      & .modal-content {
        padding: 0px 16px;
        border-radius: 0px;
        box-shadow: none;
        background: var(--ds-c-white);
        width: 100%;
        height: fit-content;
        margin-inline: auto;
        border: none;
        border-radius: 16px 16px 0 0;
      }
    }
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    & .modal-dialog {
      transform: none;
      & .modal-content {
        padding: 16px;
        box-shadow: var(--ds-bs-4);
        background: var(--ds-c-white);
        width: 436px;
        height: fit-content;
        margin-inline: auto;
        border: none;
        border-radius: 8px;
      }
    }
  }
`;
const ModalBody = styled(Modal.Body)`
  padding: 0;
  text-align: left;
  margin-bottom: 0px;
  padding-top: 20px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    padding-top: unset;
  }
`;
const ImageWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
const SubText = styled.p`
  ${paragraphMixin};
  ${paragraph500Mixin};
  text-align: center;
  white-space: break-spaces;
  color: var(--ds-c-grey-dark);
  margin: 0;

  & a {
    text-decoration: none;
    color: var(--ds-c-blue-hyperlink-default);
  }

  & b {
    color: var(--ds-c-blue-hyperlink-default);
  }
`;

const ModalFooter = styled(Modal.Footer)`
  ${displayFlexColCenterCenterMixin};
  margin-inline: -16px;
  padding-inline: 16px;
  padding-block: 16px 20px;
  border: none;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    padding-block: unset;
    padding-inline: unset;
    margin-inline: unset;
    flex-direction: row;
  }
`;

export default AccountWithEmailExistInformPopup;
